class AddToCartBundleForm extends HTMLElement {
  constructor() {
    super();

    this.gallery = document.querySelector('.product-main-element-bundles product-gallery');
    this.form = this.querySelector('form.bundle-form');
    if(!this.form){
        return;
    }
    this.packs = this.form.querySelectorAll('input[name="pack"]');
    this.sizes = this.form.querySelectorAll('input[name="size"]');
    this.priceCtn = this.form.querySelector('.product-price');
    this.finalPrice = this.form.querySelector('.final-price');
    this.comparePrice = this.form.querySelector('.compare-price');
    this.priceBadge = this.form.querySelector('.product-badges');
    this.discount = this.form.querySelector('.price-percentage .discount');
    this.submitBtn = this.form.querySelector('button.btn.add-bundle');
    this.priceButton = this.submitBtn.querySelector('.price');
    this.barButton = this.submitBtn.querySelector('.bar');
    this.bisTrigger = this.querySelector('.simplistic-bis-trigger');

    if (this.bisTrigger) {
      this.bisTrigger.addEventListener('click', () => {
        const packInputSelected = this.form.querySelector('input[name="pack"]:checked');
        const sizeInputSelected = this.form.querySelector('input[name="size"]:checked');
        if (!packInputSelected || !sizeInputSelected) return;
        const bisIds = packInputSelected.getAttribute(`data-${sizeInputSelected.value}-bis-ids`) || '';
        const variantId = bisIds.split(',')[0];
        const productId = this.bisTrigger.dataset.productId;
        const customerEmail = this.bisTrigger.dataset.email;
        if (variantId) {
          $s.bisModal({ text: window.klaviyo_body_content, variant_id: variantId, product_id: productId, email: customerEmail });
        }
      });
    }

    this.form.addEventListener('submit', (e) => {
        e.preventDefault();
        this.handleSubmit(e);
    });

    this.packs.forEach(pack => {
        pack.addEventListener('change', (e) => {
            if (e.target.checked) {
                let optionNameSpan = this.form.querySelector('.product-swatch[data-label="Pack"] .option-name span');

                const url = new URL(window.location.href);
                const params = url.searchParams;
                params.set('variant', e.target.dataset.variant);
                window.history.replaceState({}, '', url);

                if(optionNameSpan){
                    optionNameSpan.textContent = e.target.value;
                }
                this.handlePriceChange(true);

                if(this.gallery){
                    this.gallery.onVariantChange({detail: {variant: {featured_media: {id: e.target.dataset.mediaId}, bundle: true}, animate: true}});
                }
            }
        });
    });

    this.sizes.forEach(size => {
        size.addEventListener('change', (e) => {
            if (e.target.checked) {
                this.handlePriceChange();
            }
        });
    });

    this.handleOptionAvailables(true);
    this.style.pointerEvents = 'auto';
  }

  handleOptionAvailables(resetAvailables = false){
    const packInputSelected = this.form.querySelector('input[name="pack"]:checked');

    this.sizes.forEach(size => {
        const available = packInputSelected.getAttribute(`data-${size.value}-available`);

        if(available == "false"){
            size.parentElement.dataset.available = "false"
        }else{
            size.parentElement.dataset.available = "true"
        }

        if(resetAvailables){
            let currentSizeSelected = this.form.querySelector('input[name="size"]:checked');

            if(currentSizeSelected){
                currentSizeSelected.checked = false;
            }

            let firstSizeAvailable = this.form.querySelector('[data-available=true] input[name="size"]');

            if(firstSizeAvailable){
                firstSizeAvailable.checked = true;
            }

            if(this.bisTrigger) this.bisTrigger.classList.add('hide');
            this.submitBtn.style.display = '';
        }
    });

    if(this.submitBtn){
        if(!this.form.querySelector('[data-available=true] input[name="size"]')){
            this.submitBtn.disabled = true;
            this.priceCtn.style.display = 'none';
            this.barButton.style.display = 'none';
            this.priceButton.style.display = 'none';
            this.priceBadge.style.display = 'block';
        }else{
            this.submitBtn.disabled = false;
            this.priceCtn.style.display = 'flex';
            this.barButton.style.display = 'inline-block';
            this.priceButton.style.display = 'inline-block';
            this.priceBadge.style.display = 'none';
        }
    }
  }

  handlePriceChange(resetAvailables = false){
    if(resetAvailables){
        this.handleOptionAvailables(resetAvailables);
    }

    const packInputSelected = this.form.querySelector('input[name="pack"]:checked');
    const sizeInputSelected = this.form.querySelector('input[name="size"]:checked');
    const discount = (packInputSelected.dataset.bundleDiscount)? parseInt(packInputSelected.dataset.bundleDiscount) : 0;

    if(!sizeInputSelected){
        return;
    }

    const sizeKey = sizeInputSelected.value;
    const sizeAvailable = packInputSelected.getAttribute(`data-${sizeKey}-available`);

    if (sizeAvailable === 'false') {
        const bisIds = packInputSelected.getAttribute(`data-${sizeKey}-bis-ids`) || '';
        this.submitBtn.disabled = true;
        if (this.bisTrigger && bisIds) {
            this.submitBtn.style.display = 'none';
            this.bisTrigger.classList.remove('hide');
        }
        return;
    } else {
        this.submitBtn.disabled = false;
        this.submitBtn.style.display = '';
        if (this.bisTrigger) this.bisTrigger.classList.add('hide');
    }

    let currentPrice = parseFloat(packInputSelected.getAttribute(`data-${sizeKey}-price`));
    
    if(this.comparePrice && discount > 0){
        this.comparePrice.textContent = this.dataset.priceFormat.replace('0.00', (currentPrice / 100).toFixed(2));
        this.finalPrice.textContent = this.dataset.priceFormat.replace('0.00', ((currentPrice - ((currentPrice / 100) * discount)) / 100).toFixed(2));
        this.priceButton.textContent = this.dataset.priceFormat.replace('0.00', ((currentPrice - ((currentPrice / 100) * discount)) / 100).toFixed(2));
        this.discount.textContent = discount;
        this.comparePrice.style.display = 'flex';
        this.discount.parentElement.style.display = 'flex';
    }else{
        this.finalPrice.textContent = this.dataset.priceFormat.replace('0.00', (currentPrice / 100).toFixed(2));
        this.priceButton.textContent = this.dataset.priceFormat.replace('0.00', (currentPrice / 100).toFixed(2));
        this.comparePrice.style.display = 'none';
        this.discount.parentElement.style.display = 'none';
    }
  }

  handleSubmit(e){
    const packInputSelected = e.target.querySelector('input[name="pack"]:checked');
    const sizeInputSelected = e.target.querySelector('input[name="size"]:checked');

    if(packInputSelected.getAttribute(`data-${sizeInputSelected.value}`)){
        let ids = packInputSelected.getAttribute(`data-${sizeInputSelected.value}`).split(',');

        const bundleId = crypto.randomUUID();
        let formData = { items: [] };

        for (let i = 0; i < ids.length; i++) {
            const id = ids[i];

            formData.items.push({
              id: id,
              quantity: 1,
              properties: {
                _attribution: 'Rebuy Bundle Builder',
                _r_added_bundle_session_id: bundleId,
                _r_bbsi: 0,
                _source: 'Rebuy',
                _widget_id: this.dataset.rebuyWidgetId,
                _bundle_product_id: packInputSelected.dataset.bundleProductId,
                _bundle_product_handle: packInputSelected.dataset.bundleProductHandle,
              }
            });
        }

        if(formData.items.length > 0){
            let doFetch = function() {
                if (typeof window._rebuyMarkOwnAdd === 'function') window._rebuyMarkOwnAdd();
                fetch(window.Shopify.routes.root + 'cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(formData)
                })
                .then(response => response.json())
                .then(data => {
                    if($s && !data.status){
                        if (document.querySelector('[data-rebuy-id]') && window.rebuyPopupEnabled !== false) {
                            $s.notifyRebuyCartAdd(data);
                            setTimeout(function() {
                              let closeBtn = document.querySelector('.rebuy-widget__close');
                              if (closeBtn && closeBtn.offsetParent !== null) {
                                if (window.SideCart) window.SideCart.updateSideCart(false);
                              } else {
                                $s.addToCartSuccess();
                              }
                            }, 700);
                        } else {
                            $s.addToCartSuccess();
                        }
                    } else {
                        $s.addToCartFail(data.description);
                    }
                })
                .catch((error) => {
                    $s.addToCartFail(error.message);
                });
            };
            if ($s && document.querySelector('[data-rebuy-id]') && window.rebuyPopupEnabled !== false) {
                $s.rebuyReady().then(doFetch);
            } else {
                doFetch();
            }
        }
    }
    
  }
}

customElements.define('add-to-cart-bundle-form', AddToCartBundleForm);